import { render, staticRenderFns } from "./Invitees.vue?vue&type=template&id=d47e596c&scoped=true"
import script from "./Invitees.vue?vue&type=script&lang=ts&setup=true"
export * from "./Invitees.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Invitees.vue?vue&type=style&index=0&id=d47e596c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47e596c",
  null
  
)

export default component.exports